// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2O9tq","col":"styles_col__Fs3Gb"};